import invert from 'lodash/invert';
import {getNameForLicensedFont} from '~/utils/font';

import All from '~/assets/images/fontcategories/all.svg';
import Bold from '~/assets/images/fontcategories/bold.svg';
import Brush from '~/assets/images/fontcategories/brush.svg';
import Bubble from '~/assets/images/fontcategories/bubble.svg';
import Collegiate from '~/assets/images/fontcategories/collegiate.svg';
import CollegeSports from '~/assets/images/fontcategories/collegesports.svg';
import Comic from '~/assets/images/fontcategories/comic.svg';
import Curly from '~/assets/images/fontcategories/curly.svg';
import Decorative from '~/assets/images/fontcategories/decorative.svg';
import Embroidery from '~/assets/images/fontcategories/embroidery.svg';
import Eroded from '~/assets/images/fontcategories/eroded.svg';
import FuturisticScifi from '~/assets/images/fontcategories/futuristicscifi.svg';
import Gothic from '~/assets/images/fontcategories/gothic.svg';
import Greek from '~/assets/images/fontcategories/greek.svg';
import Handwritten from '~/assets/images/fontcategories/handwritten.svg';
import International from '~/assets/images/fontcategories/international.svg';
import Italic from '~/assets/images/fontcategories/italic.svg';
import JustAdded from '~/assets/images/fontcategories/justadded.svg';
import Modern from '~/assets/images/fontcategories/modern.svg';
import Narrow from '~/assets/images/fontcategories/narrow.svg';
import Outline from '~/assets/images/fontcategories/outline.svg';
import PopCulture from '~/assets/images/fontcategories/popculture.svg';
import Popular from '~/assets/images/fontcategories/popular.svg';
import Retro from '~/assets/images/fontcategories/retro.svg';
import SansSerif from '~/assets/images/fontcategories/sansserif.svg';
import Scary from '~/assets/images/fontcategories/scary.svg';
import ScriptCursive from '~/assets/images/fontcategories/scriptcursive.svg';
import Serif from '~/assets/images/fontcategories/serif.svg';
import Standard from '~/assets/images/fontcategories/standard.svg';
import Stencil from '~/assets/images/fontcategories/stencil.svg';
import Thin from '~/assets/images/fontcategories/thin.svg';
import Western from '~/assets/images/fontcategories/western.svg';
import Wide from '~/assets/images/fontcategories/wide.svg';
import Youthful from '~/assets/images/fontcategories/youthful.svg';

export const fontCategorySVGs = {
  All,
  Bold,
  Brush,
  Bubble,
  Collegiate,
  'College & Sports': CollegeSports,
  Comic,
  Curly,
  Decorative,
  Embroidery,
  Eroded,
  'Futuristic/Sci-fi': FuturisticScifi,
  Gothic,
  Greek,
  Handwritten,
  International,
  Italic,
  'Just Added': JustAdded,
  Modern,
  Narrow,
  Outline,
  'Pop Culture': PopCulture,
  Popular,
  Retro,
  'Sans Serif': SansSerif,
  Scary,
  'Script & Cursive': ScriptCursive,
  Serif,
  Standard,
  Stencil,
  Thin,
  Western,
  Wide,
  Youthful
};

export const RECENTLY_USED = 'Recently Used';
export const ALL_CATEGORIES = 'All';

export const fontCategories = [
  'All',
  'Popular',
  'Just Added',
  'Modern',
  'College & Sports',
  'Script & Cursive',
  'Brush',
  'Retro',
  'Bold',
  'Thin',
  'Serif',
  'Sans Serif',
  'Italic',
  'Outline',
  'Comic',
  'Handwritten',
  'Bubble',
  'Curly',
  'Decorative',
  'Greek',
  'Pop Culture',
  'Gothic',
  'Youthful',
  'Scary',
  'Eroded',
  'Standard',
  'Futuristic/Sci-fi',
  'Stencil',
  'Western',
  'International',
  'Embroidery'
];

export const fundraisingFontCategories = [
  'Popular',
  'All',
  'Just Added',
  'Handwritten',
  'College & Sports',
  'Modern',
  'Script & Cursive',
  'Brush',
  'Decorative',
  'Youthful',
  'Embroidery',
  'Eroded',
  'Retro',
  'Standard',
  'Stencil',
  'Greek',
  'Futuristic/Sci-fi',
  'Gothic',
  'International',
  'Western',
  'Scary',
  'Pop Culture',
  'Outline',
  'Bold',
  'Thin',
  'Comic',
  'Curly'
];

const licensedTermsFontCategoriesMap = {
  Barbie: getNameForLicensedFont('Barbie'),
  'Call of Duty': getNameForLicensedFont('Call of Duty'),
  'Coca-Cola': getNameForLicensedFont('Coca Cola'),
  'Coca Cola': getNameForLicensedFont('Coca Cola'),
  'Coca cola': getNameForLicensedFont('Coca Cola'),
  Coke: getNameForLicensedFont('Coke'),
  Disney: getNameForLicensedFont('Disney'),
  Espn: getNameForLicensedFont('Espn'),
  Friends: getNameForLicensedFont('Friends'),
  'Friends Font': getNameForLicensedFont('Friends'),
  Fortnite: getNameForLicensedFont('Fortnite'),
  'Game of Thrones': getNameForLicensedFont('Game of Thrones'),
  Gatsby: getNameForLicensedFont('Gatsby'),
  'Great Gatsby': getNameForLicensedFont('Great Gatsby'),
  'Great gatsby': getNameForLicensedFont('Great Gatsby'),
  Gucci: getNameForLicensedFont('Gucci'),
  'Harry Potter': getNameForLicensedFont('Harry Potter'),
  'Miami Vice': getNameForLicensedFont('Miami Vice'),
  Minecraft: getNameForLicensedFont('Minecraft'),
  Nasa: getNameForLicensedFont('Nasa'),
  Netflix: getNameForLicensedFont('Netflix'),
  Nirvana: getNameForLicensedFont('Nirvana'),
  Spongebob: getNameForLicensedFont('Spongebob'),
  'Star Wars': getNameForLicensedFont('Star Wars'),
  'Stranger Things': getNameForLicensedFont('Stranger Things'),
  Supreme: getNameForLicensedFont('Supreme'),
  'Taylor Swift': getNameForLicensedFont('Taylor Swift'),
  Thrasher: getNameForLicensedFont('Thrasher'),
  'Top gun': getNameForLicensedFont('Top gun')
};

const invertedLicensedTermsFontCategoriesMap = invert(
  licensedTermsFontCategoriesMap
);

export const mapFontToLicensedTerm = fontName => {
  const mappedFontName = licensedTermsFontCategoriesMap[fontName];
  return mappedFontName || fontName;
};

export const mapLicensedTermToFont = term => {
  const mappedFontName = invertedLicensedTermsFontCategoriesMap[term];
  return mappedFontName || term;
};

export const misspelledSearchTermFontCategoriesMap = {
  Grafiti: 'Graffiti',
  Grafitti: 'Graffiti',
  Buble: 'Bubble',
  Cursiv: 'Cursive',
  Varisty: 'Varsity'
};
